import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ACTIONS, EVENTO, ICONS, LoaderService, NotificationService, TOOLTIPS } from 'src/app/shared/session';
import { ParametroAutonomiaService } from '../shared/parametro-autonomia.service';
import { ParametroAutonomia } from '../shared/parametro-autonomia.model';
import { FabButtonGroupComponent } from 'src/app/shared/fabbuttongroup/fabbuttongroup.component';

@Component({
  selector: 'app-parametro-autonomia-save',
  templateUrl: './parametro-autonomia-save.component.html',
})
export class ParametroAutonomiaSaveComponent implements OnChanges {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;

  formGroupParametroAutonomia: FormGroup;
  msgErrorGuardar: string;
  obligatorioMsg: string;
  parametroAutonomia: ParametroAutonomia;
  buttonGroup: any;
  @ViewChild(FabButtonGroupComponent) fabButtonGroupComponent: FabButtonGroupComponent;

  constructor(
    public fb: FormBuilder,
    private loaderService: LoaderService,
    private parametroAutonomiaService: ParametroAutonomiaService,
    private notificationService: NotificationService
  ) { }

  ngOnChanges() {
    this.initData();
  }

  async initData() {
    this.msgErrorGuardar = 'Error al guardar parametro autonomia';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.parametroAutonomia = new ParametroAutonomia();
    this.setValuesFormBuilder();
    if (this.data != null && this.data.parametroAutonomia != null && this.data.parametroAutonomia.id != null) {
      this.parametroAutonomia = await this.parametroAutonomiaService.obtenerParametroAutonomia(this.data.parametroAutonomia.id).toPromise();
      this.setValuesFormBuilder();
    }
  }

  setValuesFormBuilder() {
    this.formGroupParametroAutonomia = this.fb.group({
      nombre: [this.parametroAutonomia.nombre, Validators.compose([Validators.required])],
    });
  }

  formGroupParametroAutonomiaSubmit(event) {
    if (this.formGroupParametroAutonomia.invalid)
      return;
    if (this.fabButtonGroupComponent.disabled) return;
    this.fabButtonGroupComponent.disabled = true;
    this.parametroAutonomia.nombre = event.value.nombre;
    this.guardarParametroAutonomia();
  }

  async guardarParametroAutonomia() {
    this.loaderService.show();
    try {
      if (this.data != null && this.data.parametroAutonomia != null && this.data.parametroAutonomia.id != null) {
        await this.parametroAutonomiaService.actualizarParametroAutonomia(this.parametroAutonomia).toPromise();
        this.notificationService.successful("Parametro autonomia actualizado con éxito");
      } else {
        let id = await this.parametroAutonomiaService.insertarParametroAutonomia(this.parametroAutonomia).toPromise();
        this.parametroAutonomia.id = id;
        this.notificationService.successful("Parametro autonomia registrado con éxito");
      }
      this.data.parametroAutonomia = { id: this.parametroAutonomia.id };
      this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
    } catch (error) {
      this.notificationService.error(this.msgErrorGuardar);
      throw error;
    } finally {
      this.loaderService.hide();
      this.fabButtonGroupComponent.disabled = false;
    }
  }
}